import { MODELS } from '../data/models';
import { PROVIDERS } from '../data/providers';
import { SYNTH_MODES } from '../data/synth-modes';
import { getCurrentLang } from './i18n';

/* =================================================================
   7. Render: synthesis selectors
   ================================================================= */
export function renderSynthModes() {
  const sel = document.getElementById("synth-mode");
  const prev = sel.value || localStorage.getItem("lp_aiboard_synth_mode") || "executive";
  sel.innerHTML = "";
  Object.keys(SYNTH_MODES).forEach(key => {
    const opt = document.createElement("option");
    opt.value = key;
    opt.textContent = SYNTH_MODES[key].labels[getCurrentLang()] || SYNTH_MODES[key].labels.en;
    sel.appendChild(opt);
  });
  sel.value = prev;
  toggleCustomVisibility();
}

export function renderSynthModelSelect() {
  const sel = document.getElementById("synth-model");
  // Default synth model = Claude Opus 5 (current Frontier). Users with a
  // saved `lp_aiboard_synth_model` keep it — MODEL_ID_ALIASES routes any
  // legacy id (e.g. claude-opus-4-7) to its successor at dispatch time.
  const prev = sel.value || localStorage.getItem("lp_aiboard_synth_model") || "claude-opus-5";
  sel.innerHTML = "";
  const byProvider = {};
  // Skip deprecated entries in the interactive picker — they still live
  // in MODELS for saved-session label / pricing resolution, but showing
  // them here creates confusing duplicates (Claude Opus 5 AND "Claude
  // Opus 4.7 (legacy)") that both resolve to the same wire call.
  MODELS.filter(m => !m.deprecated).forEach(m => {
    if (!byProvider[m.provider]) byProvider[m.provider] = [];
    byProvider[m.provider].push(m);
  });
  Object.keys(byProvider).forEach(p => {
    const group = document.createElement("optgroup");
    group.label = PROVIDERS[p].label;
    byProvider[p].forEach(m => {
      const opt = document.createElement("option");
      opt.value = m.id;
      opt.textContent = m.label;
      group.appendChild(opt);
    });
    sel.appendChild(group);
  });
  sel.value = prev || MODELS[0].id;
}

export function toggleCustomVisibility() {
  const sel = document.getElementById("synth-mode");
  const wrap = document.getElementById("synth-custom");
  wrap.classList.toggle("show", sel.value === "custom");
}

export function attachSelectorHandlers() {
  document.getElementById("synth-mode").addEventListener("change", e => {
    localStorage.setItem("lp_aiboard_synth_mode", e.target.value);
    toggleCustomVisibility();
  });
  document.getElementById("synth-model").addEventListener("change", e => {
    localStorage.setItem("lp_aiboard_synth_model", e.target.value);
  });
}
